import { CorporateDocumentationCard } from "../../Molecules/CorporateDocumentationCard";
import { Title } from "../../Atoms/Title";
import { LayoutTemplate } from "../../Templates/LayoutTemplate";

export const Documents = () => {
  return (
    <LayoutTemplate>
      <div className="text-[#2d2d2d] py-14">
        <h1 className="text-xl text-center mb-9 font-extrabold">
          Documentos para Download
        </h1>
        <p className="text-center mb-9">
          Acesse os materiais essenciais para o seu dia a dia de trabalho.
          Clique no botão para baixar o documento desejado.
        </p>
        <div className="w-fit mx-auto grid grid-cols-2 gap-x-4 gap-y-8 justify-items-center">
          <CorporateDocumentationCard docType="Cartilha_Vistoriador" />
          <CorporateDocumentationCard docType="Missao_Visao_Valores" />
          <CorporateDocumentationCard docType="Cartilha_Amarela" />
          <CorporateDocumentationCard docType="Regulamento_Interno" />
        </div>
      </div>
    </LayoutTemplate>
  );
};
